import * as _ from 'lodash'
import {
  toLocaleDateStringWithFormat,
  formatDateTimeWithFormat,
} from '@/user/helpers/i18n.helper.js'
import { ModelInfo } from './model-info'
import { AppliedStateInfo } from './applied-state-info'

/**
 * Applied Content Service
 * @class Applied Content
 * @extends AppliedStateInfo
 * @property {string} attenderId 신청 ID
 * @property {string} title 교육명
 * @property {string} startAt 시작일
 * @property {string} finishAt 종료일
 * @property {string} method 교육방식
 * @property {string} appliedDate 신청일
 * @property {string} applyState 신청상태
 */
export class AppliedInfoContent extends AppliedStateInfo {
  constructor(props) {
    super(props)
    this.lectureId = props.lectureId
    this.attenderId = props.attenderId
    this.title = props.title
    this.startAt = props.startAt
    this.finishAt = props.finishAt
    this.canceledAt = props.canceledAt
    this.method = props.method
    this.target = props.target
    this.appliedAt = props.appliedAt
    this.applyState = props.applyState
    this.progressState = props.progressState
    this.meetingUrl = props.meetingUrl
  }

  /**
   * 교육 시작 시간(포맷팅)
   * @returns {string}
   */
  get displayStartAt() {
    return _.curry(formatDateTimeWithFormat)(this.startAt)('YYYY-MM-DD')
  }

  /**
   * 교육 종료 시간(포맷팅)
   * @returns {string}
   */
  get displayFinishAt() {
    return _.curry(formatDateTimeWithFormat)(this.finishAt)('YYYY-MM-DD')
  }

  /**
   * 교육 취소일
   * @returns {string}
   */
  get displayCanceledAt() {
    return _.curry(toLocaleDateStringWithFormat)(this.canceledAt)('YYYY-MM-DD')
  }

  /**
   * 교육 신청일
   * @returns {string} 교육 신청일
   */
  get displayAppliedAt() {
    return _.curry(toLocaleDateStringWithFormat)(this.appliedAt)('YYYY-MM-DD')
  }

  /**
   * 교육 취소 가능 여부
   * @returns {boolean} 취소 가능 여부
   */
  get canCancel() {
    return this.cancelableState && this.isScheduled
  }

  get isOnline() {
    return this.method === 'ONLINE'
  }
}

/**
 * AppliedInfo Service
 * @class AppliedInfo
 * @extends ModelInfo
 * @property {array} content 교육 정보
 */
export class AppliedInfo extends ModelInfo {
  constructor(props) {
    super(props)
    this.content = props.content.map((obj) => new AppliedInfoContent(obj))
  }
}
